import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';

import { CdsLangService, CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-sw-update-ask',
  templateUrl: './sw-update-ask.component.html',
  styleUrls: ['./sw-update-ask.component.scss'],
  imports: [CdsIconModule, CdsLanguageModule],
})
export class SwUpdateAskComponent implements OnInit {
  private cdsLangService = inject(CdsLangService);

  @Output() closeEmit = new EventEmitter<void>();

  ngOnInit(): void {}

  close() {
    this.closeEmit.emit();
  }

  refresh() {
    window.location.reload();
  }

  getTextByLang(lang: string) {
    return this.cdsLangService.translate(lang);
  }
}
